import React from 'react'
import BackgroundImage from 'gatsby-background-image'
import { graphql, StaticQuery } from 'gatsby'
import NetlifyExpressNewsletterForm from './NetlifyExpressNewsletterForm'
import Loadable from 'react-loadable'

const Fade = Loadable({
  loader: () => import('react-reveal/Fade'),
  loading: () => <div>Loading...</div>
})

const GetStarted = ({ className }) => (
  <StaticQuery
    query={graphql`
    query {
      desktop: file(relativePath: { eq: "get-started-bg.jpg" }) {
        childImageSharp {
          fluid(quality: 100, maxWidth: 4160) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
    }
  `}
    render={data => {
      const imageData = data.desktop.childImageSharp.fluid
      return (
        <BackgroundImage
          Tag='section'
          className={className}
          fluid={imageData}
          backgroundColor='#040e18'
        >
          <Fade>
            <section className='hero is-medium'>
              <div className='hero-body'>

                <h1 className='title is-size-2-widescreen has-text-centered has-text-white' style={{ textShadow: '2px 2px 4px #000000' }}>Hol dir jetzt ein Angebot für deine zukünftigen Onlineverkäufe
                </h1>

                <h2 className='subtitle has-text-centered' style={{ textShadow: '2px 2px 4px #000000', color: 'orange' }}>Wir kreieren individuelle, moderne, leistungsstarke und skalierende Webshops welche dir mehr und vor allem zufriedene Kunden bringen.
                </h2>
                <div className='columns is-centered'>
                  <div className='column is-6'>
                    <div style={{ maxWidth: '350px', margin: '0 auto' }}>
                      <NetlifyExpressNewsletterForm />
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </Fade>
        </BackgroundImage>
      )
    }}
  />
)

// const StyledBackgroundSection = styled(GetStarted)`
//   width: 100%;
//   background-position: bottom center;
//   background-repeat: repeat-y;
//   background-size: cover;
//   filter: brightness(200%);
// `

export default GetStarted
